<template>
  <el-dialog :visible.sync="dialogVisible" title="升级范围设置" custom-class="custom-dialog" :close-on-click-modal="false"
    @opened="dialogOpen" @closed="dialogClose" width="390px" append-to-body>
    <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="升级范围">
            <el-radio-group v-model="form.rangeSet" @change="rangeSetChange">
                <el-radio :label="1">全部学校</el-radio>
                <el-radio :label="2">部分学校</el-radio>
            </el-radio-group>
        </el-form-item> 
 
        <el-form-item label="学校" v-if="form.rangeSet == 2">
            <el-select v-model="form.rangeValue" multiple collapse-tags placeholder="请选择学校">
                <el-option
                    v-for="item in depts"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
            </el-select>
        </el-form-item>

    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button :loading="loading" type="primary" @click="save" v-if="isShow">保存</el-button>
      <el-button @click="dialogClose">取消</el-button>
    </div>

  </el-dialog>
</template>

<script>
import http from '../../../../../common/http'

export default {
  name: 'createVersionForm',
  components: {  },
  props: {
    value: Boolean,
    applyManage: {
      type: Object,
      default() {
        return {}
      }
    },
    isShow: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      loading: false,
      dialogVisible: false,
      form: {
        rangeSet: 1,
        rangeValue:"",
        id:""
      },
      depts:[],
      rules: {
        rangeSet: [
            { required: true, message: '请选择升级范围', trigger: 'blur' }
        ]
      },
    }
  },
  watch: {
    value(val) {
      this.dialogVisible = val
    },
    dialogVisible(val) {
      this.$emit('input', val)
    },
  },
  created: function () {
  },
  methods: {
    dialogOpen() {
      // 值初始
      this.form.rangeSet = this.applyManage.rangeSet
      if(this.applyManage.rangeValue!=undefined 
            && this.applyManage.rangeValue!=""){
        this.form.rangeValue = this.applyManage.rangeValue.split(',')
      }else{
         this.form.rangeValue = ''
      }
      this.form.id = this.applyManage.id

      // 查询所有学校
      this.getDeptData()
    },
    rangeSetChange(value){
       console.log('范围设置：',value)
    },
    getDeptData(){
        //部门管理
        let url  = this.listDeptUrl;
        let data = {parentId:"0"};
        this.apiPost(url,data).then((res) => {
            if(res.status==200){
                this.depts=res.data.list;
            }else{
                this.$commonFn.showTip(res.message,3);
            }
        },(err)=>{
            console.log(err);
        });
    },
    save() {
      this.$refs.form.validate(async valid => {
        if (valid) {

            // rangeSet: 1-全部学校，2-部分学校
            let rangeValue = ""
            if(this.form.rangeSet === 2){
                rangeValue = this.form.rangeValue.join(',')
            }

            let url= this.thirdApplyManageUpdateRangeSetUrl
            let data = {
                rangeSet: this.form.rangeSet,
                rangeValue: rangeValue,
                id: this.form.id
            };
            // console.log(JSON.stringify(data))
            // return
            this.apiPost(url, data).then((res) => {
                if(res.status === 200){
                    this.$commonFn.showTip(res.message,1);
                    this.dialogVisible=false;
                    this.$parent.getData();
                }else{
                    this.$commonFn.showTip(res.message,3);
                }
            }, (err) => {
                console.log(err);
            });
            
        }
      })
    },
    dialogClose() {
      this.dialogVisible = false
    }
  },
  mixins: [http]
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/apply/thirdApply/components/rangeSet.vue